<template>
  <ListComponent title="Advance Report Config" :totalCount="totalItems">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="4" class="px-0 pt-0 pb-2">
          <v-text-field
            label="Search"
            outlined
            dense
            append-icon="mdi-magnify"
            clearable
            hide-details="auto"
            v-model="filters.search"
            @input="searchAdvanceReport"
          ></v-text-field>
        </v-col>

        <v-col
          v-if="totalItems > 0"
          cols="8"
          class="px-0 pt-0 pb-2 d-flex justify-end"
        >
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>

        <v-col cols="12" class="pa-0">
          <AgGridVue
            style="width: 100%; height: calc(100vh - 172px)"
            class="ag-theme-alpine"
            id="myGrid"
            :columnDefs="headers"
            :context="context"
            @grid-ready="onGridReady"
            :defaultColDef="defaultColDef"
            :grid-options="gridOptions"
            :suppressDragLeaveHidesColumns="true"
            :rowData="allRowList"
          ></AgGridVue>
        </v-col>
      </v-row>
    </template>

    <template #dialogs>
      <AdvanceReportForm
        v-if="permissions && (permissions.add || permissions.change)"
        v-model="showAdvanceReportDetailsForm"
        :editMode="isEditing"
        :editAdvanceReportID="editAdvanceReportID"
        @refreshList="itemsPerPageChanged(20)"
      />
      
     
    </template>

   
  </ListComponent>
</template>

<script>
import ListComponent from "@/components/General/ListComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/General/Pagination.vue";
import AdvanceReportButton from "@/components/AgGridComponents/AdvanceReportButton.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import AdvanceReportForm from "@/components/ModuleBased/dialogForms/AdvanceReportForm.vue";

import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  components: {
    ListComponent,
    AgGridVue,
    Pagination,
    AdvanceReportButton,
    agColumnHeader: CustomHeader,
    AdvanceReportForm,
  },
  data() {
    return {
      sorting: {},
      headers: [
        {
          headerName: "Name",
          field: "name",
          sortable: true,
        },
        {
          headerName: "Report Type",
          field: "report_type",
        },
        {
          headerName: "Frequency",
          field: "frequency",
        },
         {
          headerName: "Days of Month",
          field: "day_of_month",
        },
        {
          headerName: "Is Active ",
          field: "is_active",
        },
         {
          headerName: "Last Run At ",
          field: "last_run_at",
        },
         {
          headerName: "Recipients",
          field: "recipients",
        },
        
       

        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "AdvanceReportButton",
          pinned: "right",
          width: 90,
        },
      ],
      allRowList: [],
      permissions: null,

      // pagination vars
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,
      filters: {},

      // ag-grid vars
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },

      //BankDetails form
      showAdvanceReportDetailsForm: false,
      isEditing: false,
      editAdvanceReportID: null,
      bankDetailStatus: null,
      deactivatebankDetailId: null,
      deactivatebankDetailRemark: {},
      showRemarksForm: false,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    currentProfile() {
      if (JSON.parse(localStorage.getItem("userProfile"))) {
        return JSON.parse(localStorage.getItem("userProfile"));
      } else {
        return null;
      }
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },
  methods: {
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(20);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    searchAdvanceReport() {
      this.pageNo = 1;
      this.getAdvancedReportList();
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getAdvancedReportList();
    },
    prevPage() {
      this.pageNo--;
      this.getAdvancedReportList();
    },
    nextPage() {
      this.pageNo++;
      this.getAdvancedReportList();
    },
    
    getAdvancedReportList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        ...params,
        ...this.filters,
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      this.$api.advancedReport
        .getAdvancedReportLists(params)
        .then((res) => {
          this.allRowList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
   
    editAdvanceReport(id) {
      this.editAdvanceReportID = id;
      this.isEditing = true;
      this.showAdvanceReportDetailsForm = true;
    },
   
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("configuration");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
        this.getAdvancedReportList();
      }
    }
  },
};
</script>
